import React from 'react'
import PropTypes from 'prop-types'
import SuccessSpinner from './SuccessSpinner'
import { useTransition, animated } from 'react-spring'
import { getEmbeddedViewFlag } from 'portal-modules/common/utils/get-embedded-flag'
import styled from '@emotion/styled'

const StyledDiv = styled('div')`
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 99999;
`

const StyledSpan = styled('span')`
  color: ${({ theme }) => theme.text.white};
  display: block;
  font-size: 21px;
  font-weight: 700;
  position: absolute;
  top: calc(50% + 64px);
  text-align: center;
  width: 100%;
  padding: 0 20px;

  @media only screen and (max-width: 767px) {
    font-size: 18px;
    top: calc(50% + 48px);
  }

  &.complete {
    color: ${({ theme }) => theme.success.base};
  }
`

const AnimatedSpan = animated(StyledSpan)
const AnimatedDiv = animated(StyledDiv)

const wrapperStyle = { marginBottom: '24px' }

function PageLoader({ message, show, success, ...props }) {
  const wrapperTransitions = useTransition(show, null, {
    from: { opacity: 0 },
    enter: { opacity: 1 },
    leave: { opacity: 0 },
  })

  const msgTransitions = useTransition(message, null, {
    from: { opacity: 0, transform: 'translateY(100px)' },
    enter: { opacity: 1, transform: 'translateY(0px)' },
    leave: { opacity: 0, transform: 'translateY(100px)' },
  })

  const { hideMessage = false, hideloader = false } = props

  return wrapperTransitions.map(
    ({ item, props }, i) =>
      item && (
        <AnimatedDiv key={`${i}-page-loader`} style={props}>
          <div style={wrapperStyle}>
            {!hideloader && <SuccessSpinner complete={success} />}
          </div>
          {msgTransitions.map(
            (msgStyle, i) =>
              msgStyle.item && (
                <AnimatedSpan
                  key={`${i}-page-loader-msg`}
                  style={msgStyle.props}
                  className={success ? 'complete' : ''}
                >
                  {!hideMessage && message}
                </AnimatedSpan>
              ),
          )}
        </AnimatedDiv>
      ),
  )
}

PageLoader.propTypes = {
  message: PropTypes.string,
  show: PropTypes.bool,
  success: PropTypes.bool,
}

export default PageLoader